/* eslint-disable prefer-template */
/* eslint-disable default-param-last */
import { actionType } from 'Config/actionTypes';

const INITIAL_STATE = {
  data: [],
  isLoading: false,
  isError: false,
  msgError: '',
  status: '',
};
export const checkAuthReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionType.CHECK_AUTH + '_LOADING':
      return {
        ...state,
        isLoading: true,
        status: ''
      };
    case actionType.CHECK_AUTH + '_RESULT':
      return {
        ...state,
        data: action.result.data,
        isLoading: false,
        isError: false,
        msgError: '',
        status: action.result.status,
      };
    case actionType.CHECK_AUTH + '_FAILED':
      return {
        ...state,
        isError: true,
        msgError: action.err,
        isLoading: false,
        status: action.result.status,
      };
    case actionType.CHECK_AUTH + '_ERROR':
      return {
        ...state,
        isError: true,
        msgError: action.err,
        isLoading: false,
        status: action.status,
      };
    default:
      return state;
  }
};
